<template>
  <div>
    <template v-if="fetchState.pending">
      <div class="p-4"><OLoading class="w-10 mx-auto" /></div>
    </template>
    <template v-else-if="fetchState.error">
      <div>{{ $t('main.fetch-error') }}</div>
    </template>
    <template v-else>
      <div class="mt-4">
        <UserCardProfile v-for="user in state.userFollowing" :key="user._id" :user="user" />
      </div>
      <div ref="infiniteScrollRef"></div>
    </template>
  </div>
</template>
<script>
import { defineComponent, ref, useFetch, useContext, useMeta } from '@nuxtjs/composition-api';
import { useInfiniteScroll } from '@/composables/useInfiniteScroll';
import { useProfile } from '@/modules/profile/state/useProfile';
import UserCardProfile from '@/modules/profile/components/UserCardProfile';
import OLoading from '~/modules/common/components/ui/OLoading/OLoading';

export default defineComponent({
  head: {},
  components: {
    OLoading,
    UserCardProfile,
  },
  props: ['id'],
  setup(props) {
    const { state, getUserFollowing } = useProfile();
    const { $error, $cache } = useContext();
    $cache('public, max-age=30');
    const userId = props.id;
    const page = ref(1);
    const { fetchState } = useFetch(async () => {
      try {
        await getUserFollowing({ userId, page: page.value, check: true });
      } catch (error) {
        $error(error);
      }
    });

    const [infiniteScrollRef] = useInfiniteScroll(async () => {
      page.value++;
      await getUserFollowing({ userId, page: page.value, check: true });
    });

    useMeta(() => {
      return { meta: [{ hid: 'robots', name: 'robots', content: 'noindex' }] };
    });

    return {
      state,
      fetchState,
      infiniteScrollRef,
    };
  },
});
</script>
